<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Vatbbx/tc-custom/9780226853550.jpg?1728259590294" alt="This image is the cover for the book Greece in the Bronze Age"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Greece in the Bronze Age
      </h1>
      <p class="bookDescription body article font2">
        <p>From the arrival of the first men in Greece to the fall of the Mycenaean palace-town in the thirteenth century B.C., this work captures the essential qualities of each period of pre-classical civilization: the slow development of the Neolithic culture, the rich and original Early Bronze Age, the fruitful yet tragic encounter between Minoans and Mycenaean Empire. The legacy of Mycenaean religion and art is reviewed, including material found in excavated palaces and their stored wealth of frescoes, carved ivories, silver and gold jewelry, vases, and bronze weapons. The author deals with the invasions of Greece, the growth of a Greek language and some of the problems of Linear B, and the impact of Crete and the East upon the mainstream of Greek development.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emily Townsend
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b9bf634a